// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7822e0b3","622":"99e02c67"}[chunkId] + ".chunk.js";
};